<template>
  <div>
    <!-- <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
    ></video-player>-->
    <!-- <d-player ref="videoPlayer" :options="options"></d-player> -->
    <div id="dplayer" ref="dplayer"></div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import "videojs-flash";
import DPlayer from '../../../../node_modules/dplayer/dist/DPlayer.min.js'
// import '../../../../node_modules/dplayer/dist/DPlayer.min.css'
// import dPlayer from "vue-dplayer";
// import "vue-dplayer/dist/vue-dplayer.css";
export default {
    name: 'in-video',
    props: {
      source: {
        type: String,
        default: ''
      },
      freeTimes: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        player: null,
        options: {
          video: {
            url: ''
          },
          contextmenu: [
            {}
          ]
        }
      }
    },
    mounted() {
      this.player = new DPlayer({
        container:document.getElementById("dplayer"),
        autoplay: true,
        video: {
          url: this.source
        }
      })

      this.player.on('timeupdate', (e) => {
        if (this.freeTimes && e.target.currentTime > this.freeTimes) {
          this.onFreeTimes()
        }
        // console.log('当前播放时间：', e.target.currentTime); // 实时获取播放时间
      })
    },
	  created() {},
    methods: {
      onFreeTimes() {
        this.player.pause()
        this.player.seek(0)
        alert("试看结束，请联系商家购买！")
      }
    },
  }
</script>
<style lang="less" scoped>
</style>
